import clsx from "clsx";

type NavItemStateParams = {
  inverted: boolean;
  disabled: boolean;
  /** Whether the item represents the current/selected state. Default: false. */
  selected?: boolean;
};

const toneClasses = {
  default: {
    text: "text-foreground-primary",
    disabledText: "text-foreground-tertiary",
    selected: "bg-surface-tertiary",
    interactive:
      "hover:bg-surface-secondary focus-visible:bg-surface-secondary active:bg-surface-secondary",
  },
  inverted: {
    text: "text-foreground-primary-inverse",
    disabledText: "text-foreground-tertiary-inverse",
    selected: "bg-surface-tertiary-inverse",
    interactive:
      "hover:bg-surface-secondary-inverse focus-visible:bg-surface-secondary-inverse active:bg-surface-secondary-inverse",
  },
} as const;

/**
 * Shared text-color, selected-background, and hover/active-background
 * classes for the footer's NavItem variants (button, link, ...).
 */
export const getNavItemStateClasses = ({
  inverted,
  disabled,
  selected = false,
}: NavItemStateParams) => {
  const tone = toneClasses[inverted ? "inverted" : "default"];

  return clsx(
    disabled ? tone.disabledText : tone.text,
    selected && tone.selected,
    !disabled && tone.interactive,
  );
};
